import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const PROJECTS = [
  {
    title: 'Sector comercial',
    description: 'Mobiliario que refuerza la identidad de marca y mejora la experiencia del cliente.',
    image: '/assets/Images/comercial.jpg',
  },
  {
    title: 'Sector hotelero',
    description: 'Soluciones de hospedaje con confort, durabilidad y una presencia impecable.',
    image: '/assets/Images/hoteleria.jpg',
  },
  {
    title: 'Sector hospitalario',
    description: 'Entornos funcionales, seguros y pensados para el bienestar de pacientes y personal.',
    image: '/assets/Images/sector_hospitalario.jpg',
  },
  {
    title: 'Sector educativo',
    description: 'Espacios de aprendizaje equipados con mobiliario ergonómico, resistente y adaptable.',
    image: '/assets/Images/sector_educativo.jpg',
  },
];

const slideTransition = {
  initial: { opacity: 0, y: 28 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -28 },
  transition: { duration: 0.45, ease: [0.4, 0, 0.2, 1] },
};

const FeaturedSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentProject = PROJECTS[currentIndex];
  const lastIndex = PROJECTS.length - 1;

  const goNext = useCallback(() => {
    setCurrentIndex((prev) => (prev >= lastIndex ? 0 : prev + 1));
  }, [lastIndex]);

  const goPrev = useCallback(() => {
    setCurrentIndex((prev) => (prev <= 0 ? lastIndex : prev - 1));
  }, [lastIndex]);

  return (
    <section className="home-featured-section">
      <div className="container">
        <motion.div
          className="home-section-intro"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <h2 className="section-title">Sectores que atendemos</h2>
          <p className="section-subtitle">
            Experiencia en proyectos comerciales, hoteleros, hospitalarios y educativos.
          </p>
        </motion.div>

        <div className="home-sectors-carousel">
          <div className="home-sectors-image-panel">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentProject.title}
                className="home-sectors-image-frame"
                {...slideTransition}
              >
                <img src={currentProject.image} alt={currentProject.title} />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="home-sectors-content-panel">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentProject.title}
                className="home-sectors-copy"
                {...slideTransition}
              >
                <h3>{currentProject.title}</h3>
                <p>{currentProject.description}</p>
              </motion.div>
            </AnimatePresence>

            <div className="home-sectors-controls">
              <div className="home-sectors-buttons">
                <button
                  type="button"
                  className="slider-control"
                  onClick={goPrev}
                  aria-label="Sector anterior"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="18 15 12 9 6 15" />
                  </svg>
                </button>
                <button
                  type="button"
                  className="slider-control"
                  onClick={goNext}
                  aria-label="Sector siguiente"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
              </div>

              <div className="home-carousel-dots home-sectors-dots" role="tablist" aria-label="Sectores">
                {PROJECTS.map((project, index) => (
                  <button
                    key={project.title}
                    type="button"
                    role="tab"
                    className={`home-carousel-dot${currentIndex === index ? ' is-active' : ''}`}
                    aria-label={`Ver ${project.title}`}
                    aria-selected={currentIndex === index}
                    onClick={() => setCurrentIndex(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="home-featured-actions">
          <button
            type="button"
            className="btn-hero-modern-primary"
            onClick={() => {
              window.location.hash = 'contacto';
            }}
          >
            Hablar de tu proyecto
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
